import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import * as lucideIcons from "lucide-vue-next";
import { SVGAttributes } from "vue";

export type Icon = keyof typeof lucideIcons;

interface LucideProps extends SVGAttributes {
  icon: Icon;
  title?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Lucide',
  props: {
    icon: null,
    title: null
  },
  setup(__props: any) {

const props = __props as {
  icon: Icon;
  title?: string;
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(lucideIcons[props.icon]), { class: "stroke-1.5" }))
}
}

})